import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    fetchIndividualConsultation, updateIndividualConsultationForm,
    INDIVIDUAL_CONSULTATION_FETCH_REQUEST, INDIVIDUAL_CONSULTATION_FETCH_SUCCESS, INDIVIDUAL_CONSULTATION_FETCH_FAILURE,
    INDIVIDUAL_CONSULTATION_FORM_UPDATE_REQUEST, INDIVIDUAL_CONSULTATION_FORM_UPDATE_SUCCESS, INDIVIDUAL_CONSULTATION_FORM_UPDATE_FAILURE
} from './actions';
import { withTranslation } from 'react-i18next';
import FormComponents from '../assessmentForms/Components';
import AssessmentForm from '../assessmentForms/Form';
import { SubmissionError } from 'redux-form';
import { getFormValues, change, clearSubmitErrors } from 'redux-form';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ReduxBlockUi from 'react-block-ui/redux';
import 'react-block-ui/style.css';

class FormDetails extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.fetchIndividualConsultation(Number(this.props.match.params.id));
    }

    handleFormSubmit(values, isFinal, requiredFields, validationFunc) {
        const { t, individualConsultation, form, clearFormErrors } = this.props;

        clearFormErrors();

        if (isFinal) {
            let errors = {};
            if (requiredFields) {
                requiredFields.forEach(field => {
                    if (values[field] == null || values[field] === '') {	// null, undefined or empty are invalid, 0 is a valid value
                        errors[field] = t('Validator_Required');
                    }
                });
            }

            if (validationFunc) {
                errors = Object.assign(errors, validationFunc(values, t));
            }

            // throw redux-form error if fields are missing when submiting form in Final status
            if (Object.keys(errors).length > 0) {
                toast.error(t('FO_IndividualConsultationForm_ValidationErrors'));
                throw new SubmissionError(errors);
            }
        }

        this.props.updateIndividualConsultationForm(individualConsultation.id, form.id, { content: values, isFinal },
            () => toast.success(t(isFinal ? 'FO_IndividualConsultationForm_Final_Saved' : 'FO_IndividualConsultationForm_Draft_Saved')),
            (errorMessage) => toast.error(errorMessage));
    }

    render() {
        const { individualConsultation, form, currentFormValues, changeFormValue, t } = this.props;
        const { component, requiredFields, validationFunc } = form ? FormComponents(form, { showResults: true }, currentFormValues, changeFormValue) : {
            component: null, requiredFields: [], validationFunc: null
        };

        return <div>
            <ReduxBlockUi block={[INDIVIDUAL_CONSULTATION_FETCH_REQUEST, INDIVIDUAL_CONSULTATION_FORM_UPDATE_REQUEST]}
                unblock={[INDIVIDUAL_CONSULTATION_FETCH_SUCCESS, INDIVIDUAL_CONSULTATION_FETCH_FAILURE, INDIVIDUAL_CONSULTATION_FORM_UPDATE_SUCCESS, INDIVIDUAL_CONSULTATION_FORM_UPDATE_FAILURE]}>
            {form && <AssessmentForm
                title={form.name && t(`AssessmentForm_Consultation_${form.name}`)}
                description={t('FO_IndividualConsultationForm_Hint')}
                formComponent={component}
                backPath={`/individual-consultation/${individualConsultation.id}`}
                onSubmit={(values, isFinal) => this.handleFormSubmit(values, isFinal, requiredFields, validationFunc)}
                initialValues={form.content}
                isReadonly={form.status === 'Final'}
                />}
            </ReduxBlockUi>
            <ToastContainer theme='colored' />
        </div>;
    }
}

const mapStateToProps = (state, ownProps) => {
    const individualConsultation = state.entities.individualConsultations[ownProps.match.params.id];
    const form = individualConsultation && individualConsultation.forms.find(x => x.id === Number(ownProps.match.params.formId));

    return {
        individualConsultation,
        form,
        currentFormValues: getFormValues('customForm')(state)
    };
};

export default connect(mapStateToProps, {
    fetchIndividualConsultation,
    updateIndividualConsultationForm,
    changeFormValue: (field, value) => change('customForm', field, value),
    clearFormErrors: () => clearSubmitErrors('customForm')
})(withTranslation()(FormDetails));